import { areAnalyticsEnabledInEnv, useAnalytics } from '@cosuno/analytics-frontend';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationObserver = () => {
  const { trackPageView } = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    if (!areAnalyticsEnabledInEnv()) return;

    trackPageView();
  }, [location, trackPageView]);

  return null;
};

export default NavigationObserver;
